import { Fragment } from "react";
import { Outlet } from "react-router-dom";

const BackOfficeIndexPage = () => {
  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};

export default BackOfficeIndexPage;
